const baseUrl = "/customer/savedlists/v3/customers/";

const urlFactoryProvider =
  ({ apiOrigin = SERVER ? "https://api.asos.com" : window.location.origin }) =>
  path =>
    `${apiOrigin}${SERVER ? "" : "/api"}${baseUrl}${path}`;

export default urlFactoryProvider;
